import ReportList from "./ReportList";
import ReportIcon from "@mui/icons-material/Report";

const reports = {
  list: ReportList,
  icon: ReportIcon,
};

export default reports;
